import { EngagementPage } from '@/pages/EngagementPage'
import { MembersListPage } from '@/pages/MembersListPage'
import { OrganizationMembershipsPage } from '@/pages/OrganizationMembershipsPage'
import { RenewalPipelinePage } from '@/pages/RenewalPipelinePage'
import type { ContactsView } from '@/pages/StaffContactsView.types'

export type MembershipView = Extract<
  ContactsView,
  { kind: 'members' | 'organization-memberships' | 'renewal-pipeline' | 'engagement' }
>

export function isMembershipView(view: ContactsView): view is MembershipView {
  return (
    view.kind === 'members' ||
    view.kind === 'organization-memberships' ||
    view.kind === 'renewal-pipeline' ||
    view.kind === 'engagement'
  )
}

export function StaffMembershipContent({
  view,
  currentAssociationDate,
  onOpenMember,
  onOpenOrganization,
}: {
  view: MembershipView
  currentAssociationDate?: string
  onOpenMember: (contactId: number) => void
  onOpenOrganization: (contactId: number) => void
}) {
  if (view.kind === 'members')
    return (
      <MembersListPage
        onOpenMember={(member) =>
          member.kind === 'organization' && member.organization_id !== null
            ? onOpenOrganization(member.organization_id)
            : member.person_id !== null
              ? onOpenMember(member.person_id)
              : undefined
        }
      />
    )
  if (view.kind === 'organization-memberships') return <OrganizationMembershipsPage />
  if (view.kind === 'renewal-pipeline')
    return (
      <RenewalPipelinePage
        currentAssociationDate={currentAssociationDate}
        onOpenMember={onOpenMember}
        onOpenOrganization={onOpenOrganization}
      />
    )
  return <EngagementPage onOpenMember={onOpenMember} />
}
